import React, { useState, useRef, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import useDeerFlow from './hooks/DeerFlow/useDeerFlow';
import './usual.scss';
import useAgentFile from './hooks/useAgentFile';

export const getuuid = () => {
    return uuidv4();
};
const useChat = (props) => {
    const { chatStore, sessionStore, voiceCallStore } = props.store;
    const deerFlowHook = useDeerFlow();
    const { agentFileRef } = useAgentFile();
    const { setLoading, setContent, handleMessages, changeSessionMapItem, handleGetSessionMessage } = chatStore;
    const { currentSessionMapId, originMsgMap, changeOriginMsgMap, sessionMap } = sessionStore;
    // 创建唯一的页面实例ID
    useEffect(() => {
        if (!window.chatPageInstanceId) {
            const instanceId = Date.now() + '_' + Math.random().toString(36).substr(2, 9);
            window.chatPageInstanceId = instanceId;
        }
        return () => {
            // 清理页面实例ID（当组件卸载时）
            // 注意：不要在这里删除，因为可能有多个useChat实例
        };
    }, []);
    const { hideTTSActions } = voiceCallStore



    //获取当前会话的消息

    //处理会话相关----------------------------------------------------------------

    useEffect(() => {

        if (currentSessionMapId && sessionMap[currentSessionMapId]) {
            const currentMessages = originMsgMap[currentSessionMapId]?.messages || [];
            const updatedMessages = handleMessages(currentMessages);
            changeSessionMapItem(
                currentSessionMapId,
                {
                    messages: updatedMessages
                },
                currentMessages
            );
        }
    }, [hideTTSActions]);

    // 🔥 新增：将handleGetSessionMessage暴露到全局，供AIPPT组件调用
    React.useEffect(() => {
        window.handleGetSessionMessage = handleGetSessionMessage;
        return () => {
            delete window.handleGetSessionMessage;
        };
    }, [handleGetSessionMessage]);

    // 🔥 关闭多模态抽屉并重置相关状态（切换会话/菜单时使用）
    // clearReference=true 时清空引用（如切换会话/菜单）；发送消息时可传 false 保留引用

    // 切换修改计划模式 - 使用hook中的方法
    const toggleEditPlanMode = () => {
        deerFlowHook.toggleEditPlanMode(setContent);
    };

    // 重置所有研究计划的编辑状态 - 使用hook中的方法
    const resetEditPlanMode = () => {
        deerFlowHook.resetEditPlanMode();
    };

    // const { ttsMessagesRef, ttsContentRef, TTSNewMsg, TTSNewlist, resetVoiceCallStatus, resetMessageIdState, handleTTSMessageUpdate, isInVoiceCall } =
    //     useTTSHandler({
    //         currentSessionMapIdRef,
    //         originMsgMapRef,
    //         handleMessages,
    //         changeSessionMapItem,
    //         sessionListRef,
    //         formatSessionList,
    //         isNewSessionRef,
    //         setHideTTSActions,
    //         isInAnswerRef,
    //         agentId,
    //         sessionMapRef,
    //         setSessionMap
    //     });
    return {
        agentFileRef,
        editPlanMode: deerFlowHook.editPlanMode,
        toggleEditPlanMode, // 新增的属性
        resetEditPlanMode, // 正确的函数名称

        stopHistoryPolling: deerFlowHook.stopHistoryPolling, // 添加stopHistoryPolling函数

    };
};

export default useChat;
